// import { pick } from 'lodash-es'
const publicProps = [
  'cityId',
  'countyId',
  'countyGroupId',
  'lat',
  'lng',
  'poiId',
  'poiCityId',
  'poiCountyId',
  'poiCountyGroupId',
  'poiName',
  'displayName',
  'poiLat',
  'poiLng',
  'address' // 地址列表请求的时候服务端反解的时候好像用到了这个字段
]
// 项目内使用的到参数
const projectProps = [
  'addressAll',
  'aid'
]


export const plPick = (source, filter=[]) => {
  const pickProps = [...publicProps, ...projectProps, ...filter]
  // return pick(source, pickProps)
  return source
}